import { Loader, Search } from 'lucide-react';
import React, { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { truncateText, allowOnlyNumbers, companyNameFilter } from "../../util/utils";
import requestErrorHandler from "../../util/requestErrorHandler";
import axiosConfig from "../../util/axiosConfig";
import ConfirmModal from '../modal/ConfirmModal';
import { message } from 'antd';
import { OrdersType } from '../../shared/interfaces/requests.interface';
import { REQUEST_STATUS } from '../../util/constants';
import placeholder from '../../util/placeholder';

type FleetOwnerType = {
  id: string;
  name: string;
  companyName: string;
  phone: string;
  email: string;
  noOfTrips: number;
}

type FleetOwnerDetails = {
  // fleetOwner: FleetOwnerType;
  totalTrips: number;
} & FleetOwnerType;

interface FleetOwnersProps {
  request: OrdersType
}
// /newAdmin/available-truckers/:id
function FleetOwners({request: rentalRequest}: FleetOwnersProps) {
  const navigate = useNavigate()
  const [request, setRequest] = useState<OrdersType>(rentalRequest);
  const { requestId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [selectedFleet, setSelectedFleet] = useState<FleetOwnerType[]>([]);
  const [fleetOwners, setFleetOwners] = useState<FleetOwnerDetails[]>([])
  const [nameSearch, setNameSearch] = useState('');

  const isAssigned = useMemo(() => {
    return request.status === REQUEST_STATUS.ASSIGNED
  }, [request.status]);

  const filteredFleetOwners = useMemo(() => {
    return fleetOwners.filter(companyNameFilter(nameSearch))
  }, [nameSearch, fleetOwners])

  const isValidNoOfTrips = useMemo(() => {
    const totalTrips = selectedFleet.reduce((acc, item) => acc + item.noOfTrips, 0)
    return totalTrips === request.noOfTrips;
  }, [selectedFleet, request.noOfTrips])

  const handleTripCountChange = useCallback((data: FleetOwnerType) => {
    // if (data.noOfTrips) {
      const found = selectedFleet.find(v => v.id === data.id)
      // Remove item when trip count is zero
      if (found && !data.noOfTrips) {
        if (isAssigned) {
          setSelectedFleet((prev) =>
            prev.map((fleet) =>
              fleet.id === found.id ? { ...fleet, noOfTrips: data.noOfTrips } : fleet
            )
          );          
          return;
        }
        setSelectedFleet((prev) => prev.filter(fo => fo.id !== data.id))
        return;
      }

      if (found) {
        setSelectedFleet((prev) =>
          prev.map((fleet) =>
            fleet.id === found.id ? { ...fleet, noOfTrips: data.noOfTrips } : fleet
          )
        );
        return;
      }

      setSelectedFleet(prev => [...prev, {...data}])
    // }
  }, [selectedFleet]);

  const getFleetOwners = async () => {
    setIsLoading(true);
    try {
    const response = await axiosConfig.get(`/newAdmin/available-truckers/${requestId}`);
    const data = response?.data;
    setFleetOwners(data.data.map((item: any) => ({...item.fleetOwner})))
    } catch (error) {
      requestErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAssignment = useCallback(async () => {
    await initialAssignment();
    // if (!isAssigned) {
    //   return;
    // }
    // await reAssignment()
  }, [isAssigned, selectedFleet])

  const initialAssignment = async () => {
    try {
      setIsAssigning(true)
      const assignments = selectedFleet.map(item => ({noOfTrips: item.noOfTrips, fleetOwnerId: item.id}))

      const response = await axiosConfig.post(`/newAdmin/assign-request/${requestId}`, {
        truckCategoryId: request.truckCategory.id,
        assignments: assignments
      });
      setSelectedFleet([])
      message.success(response.data.message);
      // await getRequest();
      navigate('/admin/requests')
    } catch (error) {
      requestErrorHandler(error);
    } finally {
      setIsAssigning(false);
    }
  };

  // const reAssignment = async () => {
  //   try {
  //     if (!request.assignments) return;
  //     setIsAssigning(true)
  //     // Map selectedFleet to reassignments:
  //     const reassignments = selectedFleet
  //       .map(item => {
  //         // Find matching fleetOwner in the request by id
  //         const oldFleetOwner = request.assignments?.find((fleet: any) => fleet.fleetOwner.id === item.id);

  //         return {
  //           newFleetOwnerId: item.id,
  //           oldFleetOwnerId: oldFleetOwner?.id || '',
  //           noOfTrips: item.noOfTrips,
  //           oldNoOfTrips: oldFleetOwner?.tripCount ?? null,  // capture old value for comparison
  //         };
  //       })
  //       .filter(item => item.noOfTrips !== item.oldNoOfTrips)  // only include if noOfTrips changed
  //       .map(({ oldNoOfTrips, ...rest }) => rest);  // remove the helper field before returning
  //     const response = await axiosConfig.post(`/newAdmin/reassign-request/${requestId}`, {
  //       reassignments: reassignments
  //     });
  //     console.log({response});
  //     setSelectedFleet([])
  //     message.success(response.data.message);
  //     await getRequest();
  //     // navigate('/admin/requests')
  //   } catch (error) {
  //     requestErrorHandler(error);
  //   } finally {
  //     setIsAssigning(false);
  //   }
  // };

  // const getRequest = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axiosConfig.get(`/renter/rental-request/${requestId}`);
  //     // const updatedRequest = response?.data?.data;
  //     // setRequest({ ...updatedRequest })
  //     // const  fleetOwners = updatedRequest.assignments.map((item: any) => ({...item.fleetOwner, noOfTrips: item.tripCount }))
  //     // setFleetOwners(fleetOwners)
  //   } catch (error) {
  //     requestErrorHandler(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    getFleetOwners();
    // if (!isAssigned) {
    //   getFleetOwners();
    // } else {
    //   const  fleetOwners = request.assignments.map((item: any) => ({...item.fleetOwner, noOfTrips: item.tripCount }))
    //   console.log({fleetOwners: fleetOwners})
    //   setFleetOwners(fleetOwners)
    //   // setSelectedFleet(fleetOwners)
    // }
  }, [isAssigned]);

  if (isLoading) {
    return (<div className="h-96 flex items-center justify-center"><Loader /></div>);
  }

  return (
    <>
      <div className="bg-blue-200 border-solid border-transparent border-l-4 border-l-blue-700 flex items-center gap-3 p-2">
        <img src={request?.truckCategory?.image || placeholder} alt="Dump Truck" className="w-12 h-12 rounded object-cover" />
        <div>
          <div className="font-semibold text-[#1A237E] text-base">{request?.truckCategory?.name}</div>
          <div className="text-[#90A4AE] font-semibold text-sm">{request.noOfTrips} Trips requested</div>
          {request.totalAssignedTrips > 0 && (
            <div className="text-[#90A4AE] font-semibold text-sm">{request.totalAssignedTrips} Trips Assigned</div>
          )}
        </div>
      </div>
      <h2 className="font-semibold text-base text-gray-500 my-4">Assign to Fleet Owners</h2>
      <div className="flex items-center border-solid border-transparent border-b-2 border-b-[#E0E0E0] px-3 py-2">
        <Search className="size-4 text-gray-400" />
        <Input
          placeholder="Search Fleets"
          className="flex-1 border-none focus:outline-none shadow-none text-gray-600"
          value={nameSearch}
          onChange={(e) => setNameSearch(e.target.value)}
      />
      </div>
      <div className="flex flex-col gap-2 max-h-80 overflow-y-auto">
        {filteredFleetOwners.map((fleet) => (
          <FleetOwner key={fleet.id} details={fleet} onChange={handleTripCountChange} />
        ))}
      </div>
      {selectedFleet.length > 0 && (<>
        {!isValidNoOfTrips
          ? <p className="my-4 text-red-500 text-sm font-medium">Assigned trips are fewer than requested.</p>
          : <p className="my-4 text-gray-500 text-sm font-semibold">Assign to <strong className="text-primary text-sm font-semibold">{selectedFleet.length}</strong> Fleet Owners</p> 
        }
      </>)}
      <div className="flex items-center gap-0 mt-16">
        {(!selectedFleet.length && !isAssigned)
          ? (<>
            <Button disabled={!selectedFleet.length} className="w-2/5 text-white rounded-none">Assign</Button>
            <Button className="flex-1 rounded-none bg-[#5A5A7B80] text-white hover:bg-[#5A5A7B80] opacity-80">Auto Assign</Button>
          </>)
          : <ConfirmModal
            disabled={!selectedFleet.length || isAssigning}
            loading={isAssigning}
            triggerLabel={isAssigned ? 'Re-Assign' : 'Proceed'}
            triggerClassName="w-full text-white rounded-none"
            title="Confirm Allocation"
            subTitle="Trips will be assigned as follows"
            onConfirm={() => handleAssignment()}
          >
            {selectedFleet.map((fleet) => (
              <FleetOwner key={fleet.id} details={fleet} readonly />
            ))}
          </ConfirmModal>
        }
      </div>
    </>
  )
}

interface FleetOwnerProps {
  details: FleetOwnerType,
  readonly?: boolean;
  onChange?: (value: FleetOwnerType) => void;
}

function FleetOwner ({onChange, details, readonly}: FleetOwnerProps) {
    const [input, setInput] = useState('')
    const [checked, setChecked] = useState(false);

    const handleCheckChange = (val: boolean) => {
      setChecked(val)
      if (!val) {
          onChange?.({
            ...details,
            noOfTrips: 0
          });
      }
    }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      ...details,
      noOfTrips: Number(e.target.value)
    });
    setInput(e.target.value)
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1 bg-blue-200/50 border-solid border-transparent border-l-4 border-l-blue-700">
      <Label htmlFor={details.id} className="flex-1 text-[#1A237E] text-sm">{truncateText(details.name ?? details.companyName, 28)}</Label>
      {!readonly && (<Checkbox id={details.id} className="mr-2" onCheckedChange={handleCheckChange} />)}
      {checked && (
        <Input
          value={input}
          className="w-10 h-8 bg-white text-[#1A237E] border-solid border-blue-200 rounded text-xs font-semibold ml-auto"
          placeholder="0"
          disabled={!checked}
          onKeyDown={allowOnlyNumbers}
          onChange={handleChange}
        />
      )}
      {(details.noOfTrips > 0 && !readonly) && <span className="ml-auto">{details.noOfTrips}</span>}
      {readonly && <span className="ml-auto">{details.noOfTrips}</span>}
    </div>
  );
}


export default FleetOwners;